import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-marks-entry',
  templateUrl: './marks-entry.component.html',
  styleUrls: ['./marks-entry.component.scss'],
})
export class MarksEntryComponent implements OnInit {
  marksEntryForm: FormGroup;
  ListOfMarks: any;
  filteredListOfMarks: any;
  dialogRef: MatDialogRef<any>;
  Table = false;
  Upd2 = false;
  Upd1 = false;
  ListOfGrid: any;
  filteredListOfGrid: any;
  show = false;
  RGInCode = 0;
  RptCode = 0;
  IsICR = false;
  IsFile = true;
  ICRLabel = 'ICR';
  TitleOne = 'titleOne';
  TitleTwo = 'TitleTwo';
  TitleThree = 'TitleThree';
  isEC_Table = false;
  isBatch_Table = true;
  isCSNo_Table = true;
  isTbl_Table = true;
  isSrNo_Table = true;
  Generate = true;
  isSub_Table = true;
  isPaper_Table = true;
  isRollNo_Table = true;
  isRgNo_Table = true;
  isCode_Table = true;
  isPacketNo_Table = true;
  isMarks_Table = true;
  isMarksD_Table = true;
  isGRD_Table = true;
  isStatus_Table = true;
  isQNO_Table = false;
  isName_Table = false;
  isCollege_Table = true;
  isTotalErr_Table = true;
  isCH_Table = true;
  isValid_Table = true;
  isMsg_Table = true;
  isQpCode_Table = false;
  ItxtBranch = true;
  ItxtSub = true;
  ItxtHead = true;
  ItxtCSno = true;
  ItxtQPCode = true;
  ItxtSrNo = true;
  ItxtRollNo = true;
  ItxtMarks = false;
  ItxtGrade = true;
  ItxtStatus = true;
  ItxtPacketNo = true;
  ItxtValid = true;
  ItxtCsSect = true;
  ItxtCgCode = true;
  ItxtMarksD = false;
  ItxtSubkeySearch = true;
  ItxtHeadkeySearch = true;
  ItxtCode = true;
  ItxtRgNo = true;
  ItxtHeadDisabled = false;
  ItxtQPCodeDisabled = false;
  ItxtSubDisabled = false;
  ItxtCSnoDisabled = false;
  PrintVis = false;
  ItxtCSnoCaption = 'CSNo'
  G_Regn_Roll = '';
  MrksLength: any;
  MarkArray: FormArray;
  LoginId = sessionStorage.getItem('userId');
  courseClgMapList: any;
  filteredstucourseClgMapListList: any;
  APIService: string;
  assignTableData: any;
  Marks: any;
  errMsg: any;
  SessionNo: any;
  List: any;
  showtempletfile = false;
  sectionmarkstemplet = false;
  marksByRollNo = false;
  statusList: any[];
  filteredStatusList: any[];
  pageSize = 50;
  currentPage = 1;
  totalItems = 0;
  pageSizeOptions: number[] = [50, 100, 150, 200];
  prefix: string;
  RollNoPrFx
  SessionYr: any;
  RollNoForPrfx: any;
  rollNoArray = [];
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    private httpClient: HttpClient,
    private dialog: MatDialog,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    // window.scroll(0,0)
    this.Table = false;
    this.Upd2 = false;
    this.Upd1 = false;
    this.Generate = true;
    this.PrintVis = false;
    this.RptCode = 0;
    this.List = '';
    this.route.queryParams.subscribe((params) => {
      window.scroll(0, 0)
      this.RGInCode = params['MenuCode'];
      this.G_Regn_Roll = this.umsService.secretdata['RegnRoll'];
      this.loadpage(this.RGInCode);
      this.marksEntryForm = this.fb.group({
        list: new FormControl(''),
        list2: new FormControl(),
        list3: new FormControl(),
        Valid: new FormControl(),
        Chng: new FormControl(),
        Sub: new FormControl(),
        Paper: new FormControl(),
        Batch: new FormControl(),
        Subject: new FormControl(),
        Head: new FormControl(),
        CsNo: new FormControl(),
        QpCode: new FormControl(),
        Sr: new FormControl(),
        RollNo: new FormControl(),
        Marks: new FormControl(),
        MarksD: new FormControl(),
        Grade: new FormControl(),
        Status: new FormControl(),
        PacketNo: new FormControl(),
        Valid2: new FormControl(),
        RgNo: new FormControl(),
        Mesg: new FormControl(),
        CgCode: new FormControl(),
        CsSect: new FormControl(),
        Code: new FormControl(),
        MarkArray: new FormArray([]),

      });
      // this.resetValues();
      // if (this.marksEntryForm.touched == false) {
      // }
      if (JSON.parse(sessionStorage.getItem("session")) == null) {
        this.fetchSecretData();
      }
      else if (JSON.parse(sessionStorage.getItem("session")) != null) {
        let sessionData = JSON.parse(sessionStorage.getItem("session"));
        this.SessionNo = sessionData.SnNo;
        this.fetchList(this.SessionNo);
        this.checkSession(this.SessionNo)
      }
    });

    this.fetchStatus();
  }

  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
        this.fetchList(this.SessionNo);
        this.checkSession(this.SessionNo)
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    }
    );
  }

  getMarkArrayControls() {
    return (this.marksEntryForm.get('MarkArray') as FormArray).controls;
  }

  addNewRow() {
    const creds = this.marksEntryForm.controls.MarkArray as FormArray;
    creds.push(
      this.fb.group({
        GridMarks: new FormControl('',Validators.required),
        GridEcId: new FormControl(''),
        GridBatch: new FormControl(''),
        GridCsNo: new FormControl(''),
        GridSr: new FormControl(''),
        GridSub: new FormControl(''),
        GridHead: new FormControl(''),
        GridRollNo: new FormControl(''),
        GridRgNo: new FormControl(''),
        GridPacketNo: new FormControl(''),
        GridMarksD: new FormControl(''),
        GridGrade: new FormControl(''),
        GridStatus: new FormControl('NA'),
        GridRgCgCode: new FormControl(''),
        GridCsTotErr: new FormControl(''),
        GridChng: new FormControl(''),
        GridValid: new FormControl(''),
        GridMesg: new FormControl(''),
        GridQpCode: new FormControl(''),
      })
    );
  }

  validateFileds(e) {
    this.show = false;
    this.Table = false;
    this.Upd2 = false;
    this.Upd1 = false;
    if (this.RGInCode == 5) {
      if (e.EcSpFlag == '11' || e.EcSpFlag == '21') {
        this.ItxtPacketNo = true;
      } else {
        this.ItxtPacketNo = false;
      }
    }
    this.checkDecimal(e);
    this.getCourseData(e['EmCoCode'])
    this.getCourse(e['EmCoCode'])
  }

  getCourse(CoCode) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        if (res.data[0]['CoRgPrfx'] != "" && res.data[0]['CoRgPrfx'] != 0) {
          this.prefix = res.data[0]['CoRgPrfx'];
        }
        else if (res.data[0]['CoRgPrfx'] == "" || res.data[0]['CoRgPrfx'] == 0 ){
        this.prefix = ''
        }

        this.RollNoPrFx =res.data[0]['RollNoPrfx'] 
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  resetValues() {
    this.Table = false;
    this.Upd2 = false;
    this.Upd1 = false;
    this.ListOfGrid = [];
    this.ItxtSubkeySearch = true;
    this.ItxtHeadkeySearch = true;
    this.show = false;
    this.IsICR = false;
    this.IsFile = true;
    this.isEC_Table = false;
    this.isBatch_Table = true;
    this.isCSNo_Table = true;
    this.isTbl_Table = true;
    this.isSrNo_Table = true;
    this.isSub_Table = true;
    this.isPaper_Table = true;
    this.isRollNo_Table = true;
    this.isRgNo_Table = true;
    this.isCode_Table = true;
    this.isPacketNo_Table = true;
    this.isMarks_Table = true;
    this.isMarksD_Table = true;
    this.isGRD_Table = true;
    this.isStatus_Table = true;
    this.isQNO_Table = false;
    this.isName_Table = false;
    this.isCollege_Table = true;
    this.isTotalErr_Table = true;
    this.isCH_Table = true;
    this.isValid_Table = true;
    this.isMsg_Table = true;
    this.isQpCode_Table = false;
    this.ItxtBranch = true;
    this.ItxtSub = true;
    this.ItxtHead = true;
    this.ItxtCSno = true;
    this.ItxtQPCode = true;
    this.ItxtSrNo = true;
    this.ItxtRollNo = true;
    this.ItxtMarks = false;
    this.ItxtGrade = true;
    this.ItxtStatus = true;
    this.ItxtPacketNo = true;
    this.ItxtValid = true;
    this.ItxtCsSect = true;
    this.ItxtCgCode = true;
    this.ItxtMarksD = false;
    this.ItxtCode = true;
    this.ItxtRgNo = true;
    this.ItxtHeadDisabled = false;
    this.ItxtQPCodeDisabled = false;
    this.ItxtSubDisabled = false;
    this.ItxtCSnoDisabled = false;


  }
  loadpage(e) {
    // this.marksEntryForm.controls['list'].markAsUntouched();
    this.showtempletfile = false;
    this.sectionmarkstemplet = false;
    this.marksByRollNo = false;
    this.Table = false;
    this.Upd2 = false;
    this.Upd1 = false;
    if (e !== 2) {
      this.isName_Table = false; //16
      this.isCollege_Table = false; //17
      this.ItxtCgCode = false;

    }
    if (e !== 6) {
      this.isCSNo_Table = false; //2
      this.isTbl_Table = false; //3
      this.isTotalErr_Table = false; // 18
      this.ItxtCsSect = false;
      this.ItxtCSno = false;
    }
    if (e !== 5) {
      this.isPacketNo_Table = false; //10
      this.ItxtPacketNo = false;
    }
    if (e == 2 || e == 11) {
      this.isMarks_Table = false; //11
      this.isMarksD_Table = false; //12
      this.isGRD_Table = false; //13
      this.ItxtMarksD = false;
      this.ItxtMarks = false;
      this.ItxtGrade = false;
    }

    if (e !== 6 || e !== 11 || e !== 7) {
      this.isStatus_Table = false; //14
      this.ItxtStatus = false;
    }

    if (parseInt(this.umsService.secretdata['ClubPartTrans']) == 17 && e == 7) {
      this.isStatus_Table = false; //14
      this.ItxtStatus = false;
    }

    if (e == 5) {
      this.isSub_Table = false; //5
      this.isPaper_Table = false; //6
      this.isRollNo_Table = false; //7
      this.isRgNo_Table = false; //8
      this.isCode_Table = false; //9
      this.ItxtSubkeySearch = false;
      this.ItxtHeadkeySearch = false;
      this.ItxtSub = false;
      this.ItxtHead = false;
      this.ItxtQPCode = false;
      this.ItxtRollNo = false;
      this.ItxtRgNo = false;
      this.ItxtCode = false;


    } else if (e == 8) {
      this.isRollNo_Table = false; //7
      this.isRgNo_Table = false; //8
      this.ItxtRollNo = false;
      this.ItxtRgNo = false;
      this.ItxtSubDisabled = true;
      this.ItxtHeadDisabled = true;
      this.ItxtQPCodeDisabled = true;
    } else {
      this.ItxtCode = false;
      this.isCode_Table = false;
      if (this.G_Regn_Roll == "G") {
        this.isRollNo_Table = false;
        this.ItxtRollNo = false;
      } else {
        this.isRgNo_Table = true;
        this.ItxtRgNo = false;
      }
      if (e == 6) {
        this.ItxtSubDisabled = true;
        this.ItxtHeadDisabled = true;
        this.ItxtQPCodeDisabled = true;
      }
      if (e == 15) {
        this.isGRD_Table = false; //13
        this.ItxtGrade = false;
        this.ItxtCSno = true;
        this.ItxtCSnoDisabled = true;
        this.ItxtCSnoCaption = "Sec :";
        this.Generate = false;
      }
      if (e == 16) {
        this.isGRD_Table = false;//13
        this.ItxtGrade = false;
      }
    }

    if (e == 2) {
      // Barcode Name Slips
      this.TitleOne = 'Barcode Name Slips';
      this.TitleTwo = 'Barcode Name Slips';
      this.TitleThree = 'Barcode Name Slips';
      this.Generate = true;
      this.RptCode = 126
      this.loadConditions(e);
    } else if (e == 5) {
      // Barcode Marks Slips
      this.TitleOne = 'Barcode Marks Slips';
      this.TitleTwo = 'Barcode Marks Slips';
      this.TitleThree = 'Barcode Marks Slips';
      this.Generate = true;
      this.RptCode = 127
      this.loadConditions(e);
    } else if (e == 6) {
      // Control Sheets
      this.TitleOne = 'Control Sheets';
      this.TitleTwo = 'Control Sheets';
      this.TitleThree = 'Control Sheets';
      this.Generate = true;
      this.loadConditions(e);
    } else if (e == 7) {
      // Marks By RollNo
      this.TitleOne = 'Marks By RollNo';
      this.TitleTwo = 'Marks By RollNo';
      this.TitleThree = 'Marks By RollNo';
      this.Generate = true;
      this.RptCode = 128
      this.loadConditions(e);
      this.marksByRollNo = true;
      this.showtempletfile = false;
      this.sectionmarkstemplet = false;
      this.isStatus_Table = true

    } else if (e == 8) {
      // Marks By Code
      this.TitleOne = 'Marks By Code';
      this.TitleTwo = 'Marks By Code';
      this.TitleThree = 'Marks By Code';
      this.Generate = true;
      this.loadConditions(e);
    } else if (e == 11) {
      // Status Report
      this.TitleOne = 'Status Report';
      this.TitleTwo = 'Status Report';
      this.TitleThree = 'Status Report';
      this.Generate = true;
      this.RptCode = 129;
      this.loadConditions(e);
    } else if (e == 14) {
      // Change Marks
      this.TitleOne = 'Change Marks';
      this.TitleTwo = 'Change Marks';
      this.TitleThree = 'Change Marks';
      this.showtempletfile = true;
      this.sectionmarkstemplet = false;
      this.marksByRollNo = false;
      this.Generate = false;
      this.loadConditions(e);
    } else if (e == 15) {
      // Section Marks
      this.TitleOne = 'Section Marks';
      this.TitleTwo = 'Section Marks';
      this.TitleThree = 'Section Marks';
      this.Generate = false
      this.showtempletfile = false;
      this.sectionmarkstemplet = true;
      this.marksByRollNo = false;
      this.loadConditions(e);
    } else if (e == 16) {
      // Dist - Ass Marks
      this.TitleOne = 'Dist - Ass Marks';
      this.TitleTwo = 'Dist - Ass Marks';
      this.TitleThree = 'Dist - Ass Marks';
      this.Generate = true;
      this.loadConditions(e);
    }

    if (e == 2 || e == 5 || e == 7 || e == 11) {
      this.PrintVis = true;
    }
    else {
      this.PrintVis = false;
    }
  }

  loadConditions(e) {
    this.spinner.show()
    let payload = {};
    payload['InCode'] = e;
    this.umsService.checkICR(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        if (res.data[0].InICR == 'Y' || res.data[0].InICR == 'G') {
          this.IsICR = true;
          if (res.data[0].InICR == 'G') {
            this.ICRLabel = 'GEN';
          } else {
            this.ICRLabel = 'ICR';
          }
        } else {
          if (res.data[0].InICR == 'F') {
            this.IsFile = true;
          }
          this.IsICR = false;
        }
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  checkDecimal(e) {
    this.spinner.show();
    let payload = {};
    payload['EmId'] = e.EmId;
    this.umsService.checkForDecimal(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.data['EmMarksD'] == "") {
        this.ItxtMarks = true;
      } else if (res.data['EmMarksD'] == "Y") {
        this.ItxtMarksD = true;
      } else {
        this.ItxtMarks = true;
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  fetchList(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['SnNo'] = SnNo;
    payload['InCode'] = this.RGInCode;
    payload['OpId'] = sessionStorage.getItem('userId');
    this.umsService.getExmFrmDrpList(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.ListOfMarks = res.data;
        this.filteredListOfMarks = this.ListOfMarks.slice();
      }
      else{
        this.spinner.hide();
        this.ListOfMarks = [];
        this.filteredListOfMarks = [];
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.ListOfMarks = [];
      this.filteredListOfMarks = [];
    });
  }

  getCourseData(id) {
    this.spinner.show()
    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      if(res.status){
        this.spinner.hide()
        this.courseClgMapList = res.data;
        this.filteredstucourseClgMapListList = this.courseClgMapList.slice();
      }
      else{
        this.spinner.hide()
        this.courseClgMapList = []
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseClgMapList = [];
    });

  }

  saveMarksEntry() {
    this.spinner.show();
    let submitpayload = this.marksEntryForm.value;
    submitpayload['EcId'] = 0;
    this.umsService.addMarksEntry(submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        // this.stateList = [];
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchListForGrid(e) {
    this.spinner.show();
    //  let EcId =   sessionStorage.getItem('CEcId');
    //  let CgCode=   sessionStorage.getItem('ShId');
    let payload = {};
    //this.EcIdd = e.CEcId
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['CgCode'] = '';
    payload['Valid'] = this.marksEntryForm.value['Valid'];
    payload['Chng'] = this.marksEntryForm.value['Chng'];
    this.umsService.fetchMarksEntryListForGrid(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.Table = true;
        if (this.RGInCode == 7) {
          this.Upd2 = true;
        }

        this.ListOfGrid = res.data;
        this.filteredListOfGrid = this.ListOfGrid.slice();
      } else {
        this.Table = false;
        this.Upd2 = false;
      }
    });
  }

  getList(data) {
    this.List = data;
  }


  initMarksGenrate() {
    if (this.marksEntryForm.valid) {
      let subject;
      let paper;
      if (this.marksEntryForm.value['Subject'] == null) {
        subject = 'All';
      } else {
        subject = this.marksEntryForm.value['Subject'];
      }
      if (this.marksEntryForm.value['Paper'] == null) {
        paper = 'All';
      } else {
        paper = this.marksEntryForm.value['Paper'];
      }
      let data = {};
      data['message'] =
        'For Subject :-' + subject + ' \n For Paper :-' + paper + '\n Proceed?';
      data['title'] = 'Generate Marks';
      data['icon'] = 'fa fa-question';
      this.dialogRef =
        this.modalPopupService.openPopup<ConformationModelComponent>(
          ConformationModelComponent,
          data
        );
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result === 'yes') {

          this.generateMarks();
          return true;
        } else {
          let gstrVldtMesg = 'Processing Cancelled';
          let data = {};
          data['message'] = gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          return false;
        }
      });
    } else {
      if (this.marksEntryForm.invalid) {
        this.marksEntryForm.controls['list'].markAsTouched();
        return
      }

    }
  }


  ICR() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['BatchNo'] = this.marksEntryForm.value['Batch'] ? this.marksEntryForm.value['Batch'] : '';
    this.umsService.ICRMarks(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.validatedExamMarks();
        });

      }
      else {
        const data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.validatedExamMarks();
        // });
      }

    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });

  }

  generateMarks() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['ForBranches'] = '';
    payload['ForSub'] = this.marksEntryForm.value['Subject'];
    payload['ForHead'] = this.marksEntryForm.value['Head'];
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.generateExamMarks(payload).subscribe((res) => {
      
      if (res.status) {
        if (res.message == "0 Records Generated") {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
        else if (res.message != "0 Records Generated") {
          this.PreviousMarks();
        }

      }
    });
  }

  PreviousMarks(){
    this.spinner.show()
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    this.umsService.PreviousMarks(payload).subscribe((res) => {
      if (res.status) {
        
        this.validatedExamMarks();
      }
      else{
        this.spinner.hide();
      }
      
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  validatedExamMarks() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Batch'] = this.marksEntryForm.value['Batch'] ? this.marksEntryForm.value['Batch'] : '';
    payload['Sr'] = '';
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.validateGeneratedExamMarks(payload).subscribe((res) => {
      this.spinner.hide();
      let data = {};
      data['message'] = res.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      this.dialogRef.afterClosed().subscribe((result) => {
        this.Table = true;
        const latestData = this.List
        const extractListNumber = (latestData: string): number => {
          const match = latestData.match(/List (\d+)/);
          return match ? parseInt(match[1], 10) : 0;
        };
        const latestListNumber = extractListNumber(latestData);
        if (latestListNumber > 1) {
          // this.newData();
          this.loadGrid('new');
        } else {
          this.loadGrid('new');
        }
      });
    });
  }


  newData() {
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Chng'] = this.marksEntryForm.value['Chng'] ? this.marksEntryForm.value['Chng'] : '';
    payload['Valid'] = this.marksEntryForm.value['Valid'] ? this.marksEntryForm.value['Valid'] : '';
    payload['Sub'] = this.marksEntryForm.value['Subject'] ? this.marksEntryForm.value['Subject'] : '';
    payload['Head'] = this.marksEntryForm.value['Head'] ? this.marksEntryForm.value['Head'] : '';
    this.umsService.fetchGeneratedExamMarks(payload).subscribe((res) => {
      this.spinner.hide();
      this.fetchEditMarks(res.data)
    })
  }

  fetchEditMarks(data) {
    this.ListOfGrid = []
    this.assignTableData = []
    this.MarkArray = this.marksEntryForm.get('MarkArray') as FormArray;
    this.MarkArray.clear();
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Sub'] = this.marksEntryForm.value['Subject'] ? this.marksEntryForm.value['Subject'] : '';
    payload['Head'] = this.marksEntryForm.value['Head'] ? this.marksEntryForm.value['Head'] : '';
    this.umsService.fetchEditMarks(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        const latestData = data
        const previousData = res.data
        const previousDataMap = new Map(
          previousData.map(item => [`${item.Head}-${item.Sub}-${item.RgNo}`, item.Marks])
        );

        const updatedData = latestData.map((latestItem) => {
          const key = `${latestItem.Head}-${latestItem.Sub}-${latestItem.RgNo}`;
          const previousMarks = previousDataMap.get(key);

          if (previousMarks !== undefined) {
            // Update the Marks property with the value from previousData
            return { ...latestItem, Marks: previousMarks };
          }

          // If no match is found, just return the latestItem
          return latestItem;
        });
        let iserror = false;
        var bar = new Promise<void>((resolve, reject) => {
          updatedData.forEach((element, index, array) => {
            let payload = {};
            payload['EcId'] = element.EcId;
            payload['Batch'] = element.Batch;
            payload['Sr'] = element.Sr;
            payload['RollNo'] = element.RollNo;
            payload['RgNo'] = element.RgNo;
            payload['Sub'] = element.Sub;
            payload['Head'] = element.Head;
            payload['Marks'] = element.Marks;
            payload['MarksD'] = element.MarksD;
            payload['Grade'] = element.Grade;
            payload['Status'] = element.Status;
            payload['MarksQM'] = element.MarksQM;
            payload['CsSect'] = element.CsSect;
            payload['CsNo'] = element.CsNo;
            payload['BarCode'] = element.BarCode;
            payload['PacketNo'] = element.PacketNo;
            payload['ProcFlag'] = element.ProcFlag;
            payload['QpCode'] = element.QpCode;
            this.umsService.EditMarks(payload).subscribe(res => {
              this.spinner.hide();
              if (res.status == false) {
                iserror = true;
                this.errMsg = res.message
              }
              if (index === array.length - 1) resolve();
              else {
                iserror = false
                this.errMsg = res.message
              }
            }, (ERROR: HttpErrorResponse) => {
              iserror = true;
              this.errMsg = ERROR.error.message
              if (index === array.length - 1) resolve();
            });
          });
        })
        bar.then(() => {
          if (iserror == false) {
            // let data = {}
            // data['message'] = "Submitted Successfully"
            // data['title'] = 'Information'
            // data['icon'] = 'fas fa-check'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.validatedUpdateExamMarks2()
          } else {
            let data = {}
            data['message'] = this.errMsg
            data['title'] = 'Alert'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

          }
        });
      }

    })
  }

  checkSession(SessionNo){
    const payload = {};
    payload['SnNo'] = SessionNo;
    this.umsService.getSession(payload).subscribe(res => {
      if(res.status){
        this.SessionYr = res.data[0].SnYear.slice(-2)
      }
    })
  }
  loadGrid(value) {
    this.Upd2 = false;
    this.ListOfGrid = []
    this.assignTableData = []
    this.MarkArray = this.marksEntryForm.get('MarkArray') as FormArray;
    this.MarkArray.clear();
    if (this.marksEntryForm.valid) {
      this.spinner.show();
      let payload = {};
      payload['EcId'] = this.marksEntryForm.value['list'];
      payload['Chng'] = this.marksEntryForm.value['Chng'] ? this.marksEntryForm.value['Chng'] : '';
      payload['Valid'] = this.marksEntryForm.value['Valid'] ? this.marksEntryForm.value['Valid'] : '';
      payload['Sub'] = this.marksEntryForm.value['Subject'] ? this.marksEntryForm.value['Subject'] : '';
      payload['Head'] = this.marksEntryForm.value['Head'] ? this.marksEntryForm.value['Head'] : '';
      payload['PageSize'] = this.pageSize;
      payload['PageNumber'] = this.currentPage;
      this.umsService.fetchGeneratedExamMarks(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.spinner.hide();
          res.data.forEach(element => {
            if (value == 'new') {
              this.addNewRow();
            }
            else if (value == 'updated') {
              this.addNewRow();
            }
            else if (value == 'second updated') {
              this.addNewRow();
            }
          });
          this.Table = true;
          if (this.RGInCode == 7 || this.RGInCode == 14 || this.RGInCode == 15) {

            if (value == 'updated') {
              this.Upd2 = false;
            }
            else if (value == 'second updated') {
              this.Upd2 = true;
            }
            else if (value == 'new') {
              this.Upd2 = true;
            }
          }
          else {
            this.addNewRow();
          }
          this.ListOfGrid = res.data;
          this.totalItems = res.data[0].TotalRecords;
          this.assignTableData = res.data;
          this.MarkArray = this.marksEntryForm.get('MarkArray') as FormArray;
          // let rollNoArray = [];
          this.assignTableData.map((element, i) => {
           this.RollNoForPrfx = this.RollNoPrFx + element['SnYear'].slice(-2) + element['EfRollNo']
        this.rollNoArray.push(this.RollNoForPrfx);
            this.MarkArray.at(i).get('GridMarks').setValue(element['Marks'],Validators.required);
            this.MarkArray.at(i).get('GridEcId').setValue(element['EcId']);
            this.MarkArray.at(i).get('GridBatch').setValue(element['Batch']);
            this.MarkArray.at(i).get('GridCsNo').setValue(element['CsNo']);
            this.MarkArray.at(i).get('GridSr').setValue(element['Sr']);
            this.MarkArray.at(i).get('GridSub').setValue(element['Sub']);
            this.MarkArray.at(i).get('GridHead').setValue(element['Head']);
            this.MarkArray.at(i).get('GridRollNo').setValue(element['EfRollNo']); 
            // this. RollNoPrFx + element['SnYear'].slice(-2) + element['EfRollNo']
            this.MarkArray.at(i).get('GridRgNo').setValue(element['RgNo']);
            this.MarkArray.at(i).get('GridPacketNo').setValue(element['PacketNo']);
            this.MarkArray.at(i).get('GridMarksD').setValue(element['MarksD']);
            this.MarkArray.at(i).get('GridGrade').setValue(element['Grade']);
            this.MarkArray.at(i).get('GridStatus').setValue(element['Status']);
            this.MarkArray.at(i).get('GridRgCgCode').setValue(element['RgCgCode']);
            this.MarkArray.at(i).get('GridCsTotErr').setValue(element['CsTotErr']);
            this.MarkArray.at(i).get('GridChng').setValue(element['Chng']);
            this.MarkArray.at(i).get('GridValid').setValue(element['Valid']);
            this.MarkArray.at(i).get('GridMesg').setValue(element['Mesg']);
            this.MarkArray.at(i).get('GridQpCode').setValue(element['QpCode']);
          });
        }
        else {
          this.spinner.hide();
          this.Table = false;
          this.Upd2 = false;
          this.ListOfGrid = []
          this.totalItems = 0;
          this.assignTableData = []

        }

      });
    } else {
      this.marksEntryForm.controls['list'].markAsTouched();
    }
  }





  prepopulate(data) {
    let e = data.value
    this.show = true;
    this.Upd1 = true;
    this.Upd2 = false;
    this.marksEntryForm.controls['list'].setValue(e.GridEcId);
    this.marksEntryForm.controls['Batch'].setValue(e.GridBatch);
    this.marksEntryForm.controls['Sr'].setValue(e.GridSr);
    this.marksEntryForm.controls['Sub'].setValue(e.GridSub);
    this.marksEntryForm.controls['RollNo'].setValue(e.GridRollNo);
    this.marksEntryForm.controls['PacketNo'].setValue(e.GridPacketNo);
    this.marksEntryForm.controls['Marks'].setValue(e.GridMarks,Validators.required);
    this.marksEntryForm.controls['Grade'].setValue(e.GridGrade);
    this.marksEntryForm.controls['Status'].setValue(e.GridStatus);
    // this.marksEntryForm.controls['Chng'].setValue(e.GridChng);
    this.marksEntryForm.controls['Valid2'].setValue(e.GridValid);
    this.marksEntryForm.controls['Mesg'].setValue(e.GridMesg);
    this.marksEntryForm.controls['QpCode'].setValue(e.GridQpCode);
    this.marksEntryForm.controls['CsNo'].setValue(e.GridCsNo);
    this.marksEntryForm.controls['RgNo'].setValue(e.GridRgNo);
    this.marksEntryForm.controls['Head'].setValue(e.GridHead);
    this.marksEntryForm.controls['CgCode'].setValue(e.GridRgCgCode);
  }

  delete(markData) {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.deletedata(markData);
        this.dialogRef.close();
      }
      else {
        this.dialogRef.close();
      }
    });
  }
  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        EcId: id.value['GridEcId'],
        Batch: id.value['GridBatch'],
        Sr: id.value['GridSr'],

      },
    };
    this.httpClient
      .delete(this.APIService + '/inputs/EditMarks', options)
      .subscribe((s) => {
        this.spinner.hide();
        const cc = [];
        cc.push(s);
        const data = {};
        data['message'] = 'Deleted Successfully';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef.close();
          this.show = false;
          this.Table = true;
          this.loadGrid('new')
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );

      });
  }


  updateMultiple() {
      this.MarkArray = this.marksEntryForm.get('MarkArray') as FormArray;
      if (this.MarkArray.invalid) {
        this.MarkArray.controls.forEach(element => {
          element.get('GridMarks').markAsTouched();
        })
        return
      }
    else {
      this.updateAll()
      return
    }
  }

  updateAll(){
    this.spinner.show();
    this.MarkArray = this.marksEntryForm.get('MarkArray') as FormArray;
    this.Marks = this.MarkArray.value
    // let payload = abcd.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Marks.forEach((element, index, array) => {
        let payload = {};
        payload['EcId'] = element.GridEcId;
        payload['Batch'] = element.GridBatch;
        payload['Sr'] = element.GridSr;
        payload['RollNo'] = element.GridRollNo;
        payload['RgNo'] = element.GridRgNo;
        payload['Sub'] = element.GridSub;
        payload['Head'] = element.GridHead;
        payload['Marks'] = element.GridMarks;
        payload['MarksD'] = element.GridMarksD;
        payload['Grade'] = element.GridGrade;
        payload['Status'] = element.GridStatus;
        payload['MarksQM'] = '';
        payload['CsSect'] = '';
        payload['CsNo'] = element.GridCsNo;
        payload['BarCode'] = 0;
        payload['PacketNo'] = element.GridPacketNo;
        payload['ProcFlag'] = '';
        payload['QpCode'] = element.GridQpCode;
        this.umsService.EditMarks(payload).subscribe(res => {
         
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        
        // let data = {}
        // data['message'] = "Submitted Successfully"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.validatedExamMarks1('second updated');
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    });
  }

  validatedExamMarks1(value) {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Batch'] = this.marksEntryForm.value['Batch'] ? this.marksEntryForm.value['Batch'] : '';
    payload['Sr'] = '';
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.validateGeneratedExamMarks(payload).subscribe((res) => {
      this.spinner.hide();
      // if (res.message == '') {
      this.loadGrid(value);
      let data = {};
      data['message'] = res.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // }
    });
  }



  updateMarks() {
    let payload = {};
    payload['EcId'] = parseInt(this.marksEntryForm.value['list']);
    payload['Batch'] = this.marksEntryForm.value['Batch'];
    payload['Sr'] = parseInt(this.marksEntryForm.value['Sr']);
    payload['RollNo'] = parseInt(this.marksEntryForm.value['RollNo']);
    payload['RgNo'] = this.marksEntryForm.value['RgNo'];
    payload['Sub'] = this.marksEntryForm.value['Sub'];
    payload['Head'] = this.marksEntryForm.value['Head'];
    payload['Marks'] = parseInt(this.marksEntryForm.value['Marks']);
    payload['MarksD'] = 0.0;
    payload['Grade'] = '';
    payload['Status'] = '';
    payload['MarksQM'] = '';
    payload['CsSect'] = this.marksEntryForm.value['CsSect'];
    payload['CsNo'] = parseInt(this.marksEntryForm.value['CsNo']);
    payload['BarCode'] = 0;
    payload['PacketNo'] = '';
    payload['ProcFlag'] = '';
    payload['QpCode'] = '';
    this.umsService.EditMarks(payload).subscribe((res) => {
      if (res.status) {
        this.validatedExamMarks();
      }
    });
  }

  validatedUpdateExamMarks2() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Batch'] = this.marksEntryForm.value['Batch'];
    payload['Sr'] = '';
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.validateGeneratedExamMarks(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.loadGrid('second updated');
      }
    });
  }

  validatedUpdateExamMarks() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Batch'] = this.marksEntryForm.value['Batch'];
    payload['Sr'] = '';
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.validateGeneratedExamMarks(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.message == '') {
        this.loadGrid('updated');
      }
    });
  }

  File(event: any) {

    const data = {};
    data['message'] = 'Do You Want To Upload This File ?';
    data['title'] = 'Information';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.dialogRef.close();
        const files: FileList = event.target.files;
        const allowedExtensions = ['csv'];

        if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            const file: File = files[i];
            const extension = file.name.split('.').pop().toLowerCase();

            if (allowedExtensions.includes(extension)) {
              // Process the selected file here (e.g., read its content or upload it)
              let data = {};
              data['message'] = 'File Uploaded Successfully';
              data['title'] = 'Information';
              data['icon'] = 'fas fa-check';
              this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
                AlertBoxComponent,
                data
              );
              this.dialogRef.afterClosed().subscribe(result => {
                this.readFileContent(file);
                });
             
            }
          }
        }
      }
      else {
        this.dialogRef.close();
      }
    });




  }


  readFileContent(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const contents = e.target.result;
      this.processCsvContents(contents);
    };
    reader.readAsText(file);
  }

  processCsvContents(contents: string): void {
    // Split the contents into lines
    const lines = contents.split('\n');
    this.spinner.show();
    // Process each line and store as comma-separated string
    const dataArray = [];
    for (const line of lines) {
      const trimmedLine = line.trim();
      if (trimmedLine) {
        dataArray.push(trimmedLine);
      }
    }
    
    const transformedData =dataArray.map((item,i) => {
      // if(item. != 0){
        const parts = item.split(',');
      return {
        EcId:this.marksEntryForm.value['list'],
        Data: parts.join(',')
      };
      // }
      
    });
    transformedData.shift();
    let payload = {
      // "EcId": this.marksEntryForm.value['list'],
      "Data": transformedData
    };
    
    this.umsService.ICRTxt(payload).subscribe((res) => {
      
      let data = {};
      data['message'] = res.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      if(res.status == true){
        // this.spinner.hide();
        this.SearchEditMarks();
        // this.ControlLock2(parseInt(this.LoginId));
      }
    });
  }



  SearchEditMarks() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Chng'] = this.marksEntryForm.value['Chng'] ? this.marksEntryForm.value['Chng'] : '';
    payload['Valid'] = this.marksEntryForm.value['Valid'] ? this.marksEntryForm.value['Valid'] : '';
    payload['Sub'] = this.marksEntryForm.value['Sub'] ? this.marksEntryForm.value['Sub'] : '';
    payload['Head'] = this.marksEntryForm.value['Head'] ? this.marksEntryForm.value['Head'] : '';
    this.umsService.fetchGeneratedExamMarks(payload).subscribe((res) => {
      
      if (res.status) {
        this.MrksLength = res.data.length;
        if (this.MrksLength == 4000) {
          this.ControlLock(0);
        }
        else{
          this.ControlLock2(parseInt(this.LoginId));  //need to verify the logic from vb and ajay sir 18/7/2024
          // this.spinner.hide();
        }
      }
      else{
        this.spinner.hide();
      }
    });
  }


  ControlLock(userId) {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['LoginId'] = userId;
    this.umsService.ControlLock(payload).subscribe((res) => {
     
      if (res.status) {
        // this.spinner.hide();
        this.ValidateMrks();
      }
      else{
        this.spinner.hide()
      }
    });
  }

  ControlLock2(userId) {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['LoginId'] = userId;
    this.umsService.ControlLock(payload).subscribe((res) => {
     
      if (res.status) {
        // this.spinner.hide();
        this.ValidateMrks2();
      }
      else{
        this.spinner.hide();
        // this.ValidateMrks2();
      }
    });
  }

  ValidateMrks2() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Batch'] = '';
    payload['Sr'] = 0;
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.ValidateMarks(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
      }
      else{
        this.spinner.hide();
      }
    });
  }


  ValidateMrks() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    payload['Batch'] = '';
    payload['Sr'] = 0;
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.ValidateMarks(payload).subscribe((res) => {
      
      if (res.status) {
        this.spinner.hide();
        this.ChangeMrks();
      }
      else{
        this.spinner.hide();
      }
    });
  }


  ChangeMrks() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    this.umsService.ChangeMarks(payload).subscribe((res) => {
      this.spinner.hide();
      this.MrksLength = 0;
      // this.ControlLock(parseInt(this.LoginId))
      if (res.status) {

      }
    });
  }

  print() {
    let submitpayload = this.marksEntryForm.value;
    let payload1 = {}
    payload1['MenuName'] = this.TitleOne;
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": this.RptCode,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  handleTab(event: Event, i) {
    const inputValue = (event.target as HTMLInputElement).value;
    let taskListArrays = this.marksEntryForm.get('MarkArray') as FormArray;
    if (!/^\d+(\.\d+)?$/.test(inputValue)) {
      taskListArrays.controls[i].get('GridMarks').setErrors({ NonNumericError: true });
    }
  }
// handleTab(event: Event, i: number) {
//   const input = event.target as HTMLInputElement;
//   const inputValue = input.value.trim();
//   let taskListArrays = this.marksEntryForm.get('MarkArray') as FormArray;
//   const control = taskListArrays.controls[i].get('GridMarks');

//   // Validate: must be a number (integer or decimal)
//   if (!/^\d+(\.\d+)?$/.test(inputValue)) {
//     control?.setErrors({ NonNumericError: true });
//   } 
//   // else {
//   //   // Convert and round
//   //   const roundedValue = Math.round(parseFloat(inputValue));

//   //   // Set value both to form and to input field (to avoid sync issues)
//   //   control?.setValue(roundedValue);
//   //   input.value = roundedValue.toString(); // update the input box manually
//   //   control?.setErrors(null);
//   // }
// }

  // dowload() {
  //   const link = document.createElement("a");
  //   link.href = '../../assets/excel/changemarks.csv';
  //   link.download = 'Download';
  //   link.click()
  // }


  // dowload2() {
  //   const link = document.createElement("a");
  //   link.href = '../../assets/excel/sectionmarks.csv';
  //   link.download = 'Download';
  //   link.click()
  // }

  // dowload3() {
  //   const link = document.createElement("a");
  //   link.href = '../../assets/excel/MARKS_ENTRY.csv';
  //   link.download = 'Download';
  //   link.click()
  // }

  fetchStatus() {
    const payload = {};
    this.statusList = [];
    this.filteredStatusList = [];
    payload['CdType'] = 'ST';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.statusList = res.data;
        this.filteredStatusList = this.statusList.slice();
        //this.castGene(payload)
      } else {
      }
    });

  }

  onStatusChange(selectedStatus: string, index: number) {
    let taskListArrays = this.marksEntryForm.get('MarkArray') as FormArray;
    if (selectedStatus == 'A') {
      taskListArrays.controls[index].get('GridMarks').setValue(0);
    }
  }

  isMarksDisabled(index: number): boolean {
    let taskListArrays = this.marksEntryForm.get('MarkArray') as FormArray;
    const statusControl = (taskListArrays.controls[index] as FormGroup).get('GridStatus');
    if (statusControl.value === 'A') {
      return true
    }
    else {
      return false
    }

  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.loadGrid('new');
  }

  download(event: Event){
    event.preventDefault();
    const payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    this.umsService.DownloadChangeMarks(payload).subscribe((res) => {
      if (res.status) {
        const extractedData = res.data.map(element => ({
          ExamCode: element.ExamCode,
          sub: element.sub,
          paper: element.paper,
          section: element.section,
          RegNo: element.RegNo,
          Marks: element.Marks,
        }));
    
        // Convert array data to CSV format
        const csvContent = this.convertArrayToCSV(extractedData);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'data.csv'; // You can change the file name if needed
        document.body.appendChild(link);
    
        // Trigger the download
        link.click();
      } else {
      }
    });
  }

  download2(event: Event){
    event.preventDefault();
    const payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    this.umsService.DownloadSectionMarks(payload).subscribe((res) => {
      if (res.status) {
        const extractedData = res.data.map(element => ({
          ExamCode: element.ExamCode,
          sub: element.sub,
          paper: element.paper,
          section: element.section,
          RegNo: element.RegNo,
          Marks: element.Marks,
        }));
    
        // Convert array data to CSV format
        const csvContent = this.convertArrayToCSV(extractedData);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'data.csv'; // You can change the file name if needed
        document.body.appendChild(link);
    
        // Trigger the download
        link.click();
      } else {
      }
    });
  }

  download3(event: Event) {
    event.preventDefault();
    const payload = {};
    payload['EcId'] = this.marksEntryForm.value['list'];
    this.umsService.DownloadMarks(payload).subscribe((res) => {
      if (res.status) {
        const extractedData = res.data.map(element => ({
          ExamCode: element.ExamCode,
          sub: element.sub,
          paper: element.paper,
          section: element.section,
          RegNo: element.RegNo,
          Marks: element.Marks,
          RollNo: element.RollNoPrfx
        }));
    
        // Convert array data to CSV format
        const csvContent = this.convertArrayToCSV(extractedData);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'data.csv'; // You can change the file name if needed
        document.body.appendChild(link);
    
        // Trigger the download
        link.click();
      } else {
      }
    });
  
  }

  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }

}
